import { dateHelper } from '../_helpers/date.helper';
import CpfCnpjInput from '../components/inputs/CpfCnpjInput';
import DatePickerInput from '../components/inputs/DatePickerInput';
import FormInput from '../components/inputs/FormInput';
import TimePicker from '../components/inputs/TimePicker';
import SelectInput from '../components/inputs/SelectInput';

export const objectsConstants = {
  //ABILITY
  ATENDIMENTO_PRIORITARIO: [
    { name: 'IDOSO', description: 'Idoso' },
    { name: 'CADEIRANTE', description: 'Cadeirante' },
    { name: 'GRAVIDAS', description: 'Grávidas' },
    { name: 'RISCO_QUEDA', description: 'Risco de queda' },
    { name: 'TEA', description: 'TEA' },
  ],
  INDISPONIBILIDADE: 'INDISPONIBILIDADE',
  DELETE: 'DELETE',
  INSERT: 'INSERT',
  PUBLIC: 'PUBLIC',
  MENU_EXAME: 'MENU_EXAME',
  MENU_MEDICO: 'MENU_MEDICO',
  MENU_VOUCHER: 'MENU_VOUCHER',
  MENU_DASHBOARD: 'MENU_DASHBOARD',
  MENU_INTEGRACAO: 'MENU_INTEGRACAO',
  MENU_INTEGRACAO_CONNECT: 'MENU_INTEGRACAO_CONNECT',
  MENU_INTEGRACAO_SASC: 'MENU_INTEGRACAO_SASC',
  MENU_AGENDA: 'MENU_AGENDA',
  MENU_CODE4: 'MENU_CODE4',
  MENU_PACIENTE: 'MENU_PACIENTE',
  MENU_USUARIO: 'MENU_USUARIO',
  MENU_TAREFAS: 'MENU_TAREFAS',
  MENU_PACOTES: 'MENU_PACOTES',
  ALTERAR_LOCAL_ATENDIMENTO_MEDICO: 'ALTERAR_LOCAL_ATENDIMENTO_MEDICO',
  MENU_AGENDAMENTO_RAPIDO: 'MENU_AGENDAMENTO_RAPIDO',
  MENU_PARAMETRIZACAO: 'MENU_PARAMETRIZACAO',
  MENU_PARAMETRIZACAO_TRIAGEM: 'MENU_PARAMETRIZACAO_TRIAGEM',
  MENU_SUPORTE: 'MENU_SUPORTE',
  CRUD_ANAMNESE_VISUALIZAR: 'CRUD_ANAMNESE_VISUALIZAR',
  CRUD_ANAMNESE_CRIAR: 'CRUD_ANAMNESE_CRIAR',
  CRUD_MEDICO_EDITAR: 'CRUD_MEDICO_EDITAR',
  CRUD_PACOTE_EDITAR: 'CRUD_PACOTE_EDITAR',
  CRUD_USUARIO_EDITAR: 'CRUD_USUARIO_EDITAR',
  CRUD_ESTOQUE_EDITAR: 'CRUD_USUARIO_EDITAR',
  CRUD_PACIENTE_EDITAR: 'CRUD_PACIENTE_EDITAR',
  CRUD_PARAMETRIZACAO_TRIAGEM: 'CRUD_PARAMETRIZACAO_TRIAGEM',
  MENU_ADMINNISTRADOR: 'MENU_ADMINNISTRADOR',
  CRUD_ESTABELECIMENTOS: 'CRUD_ESTABELECIMENTOS',
  CRUD_ESTABELECIMENTOS_EDITAR: 'CRUD_ESTABELECIMENTOS_EDITAR',
  CRUD_RELATORIOS: 'CRUD_RELATORIOS',
  CRUD_RELATORIOS_EXAMES: 'CRUD_RELATORIOS_EXAMES',
  MENU_RELATORIOS: 'MENU_RELATORIOS',
  MENU_FINANCEIRO: 'MENU_FINANCEIRO',
  CRUD_EMPRESA_FINANCEIRO: 'CRUD_EMPRESA_FINANCEIRO',
  CRUD_ESTABELECIMENTO_FINANCEIRO: 'CRUD_ESTABELECIMENTO_FINANCEIRO',
  CRUD_USUARIOS_FINANCEIRO: 'CRUD_USUARIOS_FINANCEIRO',
  MENU_RELATORIO_EXAME: 'MENU_RELATORIO_EXAME',
  CRUD_DASHBORAD_FINANCEIRO: 'CRUD_DASHBORAD_FINANCEIRO',
  CRUD_AGENDAMENTO_RAPIDO: 'CRUD_AGENDAMENTO_RAPIDO',
  CRUD_EMPRESA_CRIAR: 'CRUD_EMPRESA_CRIAR',
  CRUD_EMPRESA_EDITAR: 'CRUD_EMPRESA_EDITAR',
  CRUD_INTEGRACAO: 'CRUD_INTEGRACAO',
  CRUD_PACOTE: 'CRUD_PACOTE',
  CRUD_MODELO_RECEITUARIO: 'CRUD_MODELO_RECEITUARIO',
  AGENDA_ATENDER: 'AGENDA_ATENDER',
  AGENDA_ATENDIDO: 'AGENDA_ATENDIDO',
  AGENDA_COMPARECER: 'AGENDA_COMPARECER',
  AGENDA_VALIDAR_ELEGIBILIDADE: 'AGENDA_VALIDAR_ELEGIBILIDADE',
  AGENDA_MARCAR: 'AGENDA_MARCAR',
  AGENDA_DESMARCAR: 'AGENDA_DESMARCAR',
  VERIFICAR_ATENDIMENTO: 'VERIFICAR_ATENDIMENTO',
  REMARCACAO_CONSULTA: 'REMARCACAO_CONSULTA',
  AGENDA_TRIAGEM: 'AGENDA_TRIAGEM',
  FILTRO_PERIODO: {
    manha: { inicio: '06:00', fim: '11:59' },
    tarde: { inicio: '12:00', fim: '17:59' },
    noite: { inicio: '18:00', fim: '23:59' },
  },
  STATUS_DESCRICAO: {
    MARCADO: 'Marcado',
    ATENDIDO: 'Atendido',
    CANCELADO: 'Cancelado',
    AGUARDANDO_ATENDIMENTO: 'Aguardando atendimento',
    EM_ATENDIMENTO: 'Em atendimento',
    EM_CHAMADA: 'Em chamada',
    MARCACOES_FORA_HORARIO_MEDICO: 'Fora do horário',
    NAO_COMPARECEU: 'Não compareceu',
    AGUARDANDO_RECEPCAO: 'Aguardando recepção',
    REAGENDADA: 'Reagendada',
    RECEPCAO_INTERNA: 'Aguardando recepção interna',
    AGUARDANDO_TRIAGEM: 'Aguardando triagem ',
  },
  STATUS_MARCACAO: [
    'MARCADO',
    'AGUARDANDO_ATENDIMENTO',
    'ATENDIDO',
    'EM_CHAMADA',
    'RECEPCAO_INTERNA',
    'AGUARDANDO_TRIAGEM',
  ],
  TIPOS_DOCUMENTOS_ASSINADOS: [
    { name: 'MEDICAL_STATEMENT', description: 'Atestado/Laudo médico' },
    { name: 'MEDICAL_REPORT', description: 'Encaminhamento médico' },
    {
      name: 'MEDICAL_PRESCRIPTION',
      description: 'Receita médica',
    },
    { name: 'MEDICAL_ATTENTION', description: 'Orientação/cuidados médicos' },
    { name: 'MEDICAL_RELEASE', description: 'Alta médica' },
    // { name: 'VACCINATION', description: 'Vacinação' },
  ],
  ROLE_STATUS_AGENDA: [
    { status: 'MARCADO', permission: 'AGENDA_COMPARECER', prioridade: 1 },
    {
      status: 'AGUARDANDO_ATENDIMENTO',
      permission: 'AGENDA_ATENDER',
      prioridade: 4,
    },
    { status: 'EM_CHAMADA', permission: 'AGENDA_ATENDIDO', prioridade: 3 },
    {
      status: 'RECEPCAO_INTERNA',
      permission: 'AGENDA_VALIDAR_ELEGIBILIDADE',
      prioridade: 0,
    },
    {
      status: 'AGUARDANDO_TRIAGEM',
      permission: 'AGENDA_TRIAGEM',
      prioridade: 2,
    },
  ],
  REOPEN: 'REOPEN',
  REPROVE: 'REPROVE',
  APROVE: 'APROVE',
  TYPE_EXCLUIR: 'TYPE_EXCLUIR',
  TYPE_WARNING: 'TYPE_WARNING',
  TYPE_CANCEL: 'TYPE_CANCEL',
  EM_ATENDIMENTO: 'EM_ATENDIMENTO',
  AGUARDANDO_ATENDIMENTO: 'AGUARDANDO_ATENDIMENTO',
  ATENDIDO: 'ATENDIDO',
  MARCADO: 'MARCADO',
  AGUARDANDO_RECEPCAO: 'AGUARDANDO_RECEPCAO',
  CANCELADO: 'CANCELADO',
  EM_CHAMADA: 'EM_CHAMADA',
  MARCACAO_RECORRENTE: 'MARCACAO_RECORRENTE',
  MARCACOES_FORA_HORARIO_MEDICO: 'MARCACOES_FORA_HORARIO_MEDICO',
  NAO_COMPARECEU: 'NAO_COMPARECEU',
  AGENDAMENTO_ONLINE: 'AGENDAMENTO_ONLINE',
  PERFIL: 'perfil',
  EXISTE_MARCACAO_HORARIO_EXCLUIDO: 'EXISTE_MARCACAO_HORARIO_EXCLUIDO',
  TIPO_HISTORICO_MARCACAO: 'TIPO_HISTORICO_MARCACAO',
  TIPO_HISTORICO_PACIENTE: 'TIPO_HISTORICO_PACIENTE',
  TIPO_HISTORICO_MEDICO: 'TIPO_HISTORICO_MEDICO',
  TIPO_HISTORICO_ESTABELECIMENTO_MEDICO:
    'TIPO_HISTORICO_ESTABELECIMENTO_MEDICO',
  CARTAO_CREDITO: 'CARTAO_CREDITO',
  BOLETO: 'BOLETO',
  TRIAL_VERSION: 'TRIAL_VERSION',
  RECEPCAO_INTERNA: 'RECEPCAO_INTERNA',
  AGUARDANDO_TRIAGEM: 'AGUARDANDO_TRIAGEM',
  //FIM ABILITY
  FILA_BLOQUEADA: 'BLOQUEADA',
  FILA_INATIVA: 'INATIVA',
  USO_INDEVIDO: 6,
  TIPO_FATURAMENTOS: [
    { name: 'ESTABELECIMENTO', description: 'Estabelecimento' },
    { name: 'COOPERADO', description: 'Cooperado' },
  ],
  TIPO_INTEGRACAO: [
    { name: 'NENHUMA', description: 'Nenhuma' },
    { name: 'SASC_CONNECT', description: 'SASC Connect' },
    { name: 'SASC', description: 'SASC' },
  ],
  NA_MARCACAO: 'NA_MARCACAO',
  NA_CONFIRMACAO: 'NA_CONFIRMACAO',
  NAO_OBRIGATORIO: 'NAO_OBRIGATORIO',

  TIPO_OBRIGATORIEDADE: [
    {
      name: 'NA_MARCACAO',
      description: 'Obrigatório na marcação do agendamento',
    },
    {
      name: 'NA_CONFIRMACAO',
      description: 'Obrigatório na confirmação do agendamento',
    },
    { name: 'NAO_OBRIGATORIO', description: 'Não obrigatório' },
  ],
  TIPO_HORARIO_FUNCIONAMENTO_ESTABELECIMENTO: 'ESTABELECIMENTO',
  TIPO_HORARIO_FUNCIONAMENTO_ESTABELECIMENTO_MEDICO: 'ESTABELECIMENTO_MEDICO',
  PARTES: [
    { nome: 'PARAFUSO', qtd: 8 },
    { nome: 'PINO', qtd: 8 },
    { nome: 'TERMINAL', qtd: 2 },
  ],
  TIPOS_SEXO: [
    { name: 'M', description: 'M' },
    { name: 'F', description: 'F' },
  ],
  UNIDADES: [
    { name: 'MILILITROS', description: 'Mililitros' },
    { name: 'GRAMAS', description: 'Gramas' },
    { name: 'UNITARIO', description: 'Unidade' },
  ],
  SIM_NAO: [
    { label: 'Não', value: false },
    { label: 'Sim', value: true },
  ],
  TEMPO_ATENDIMENTO: [
    { name: '15', description: '0:15', value: 15 },
    { name: '20', description: '0:20', value: 20 },
    { name: '30', description: '0:30', value: 30 },
    { name: '40', description: '0:40', value: 40 },
    { name: '45', description: '0:45', value: 45 },
    { name: '50', description: '0:50', value: 50 },
    { nome: '60', description: '1:00', value: 60 },
    { nome: '90', description: '1:30', value: 90 },
    { nome: '120', description: '2:00', value: 120 },
  ],

  REPETIR_HORARIO: [
    { name: 'SEMANAL', description: 'Toda semana', codigo: 7 },
    { name: 'QUINZENAL', description: 'A cada duas semanas', codigo: 14 },
    { name: 'MENSAL', description: 'Uma vez por mês', codigo: 30 },
  ],

  TIPO_DOCUMENTO: [
    { name: 'TEXT', description: 'Texto', component: FormInput },
    { name: 'CPF', description: 'CPF', component: CpfCnpjInput },
    { name: 'NUMBER', description: 'Número', component: FormInput },
    {
      name: 'DATE',
      description: 'Data',
      component: DatePickerInput,
      format: dateHelper.formatDate,
    },
    {
      name: 'TIME',
      description: 'Hora',
      component: TimePicker,
      format: dateHelper.getHourFormat,
    },
    { name: 'SELECT', description: 'Seleção', component: SelectInput },
  ],

  TIPO_AGENDA: [
    { name: 'CONSULTAS', description: 'Consultas' },
    { name: 'EXAMES', description: 'Exames' },
  ],

  COMPARTILHAMENTO_PACIENTES: [
    { name: 'TODAS_EMPRESAS', description: 'Com todas empresas do sistema' },
    { name: 'EMPRESA', description: 'Somente com a minha empresa' },
    { name: 'ESTABELECIMENTO', description: 'Somente com esse estabelecimento' },

  ],



  FORMA_PAGAMENTO: [
    // { name: 'CARTAO_CREDITO', description: 'Cartão de crédito' },
    { name: 'TRIAL_VERSION', description: 'Teste gratuito por 30 dias' },
    // { name: 'BOLETO', description: 'Boleto bancário' },
  ],

  MESES: [
    { description: 'Janeiro', name: '01' },
    { description: 'Fevereiro', name: '02' },
    { description: 'Março', name: '03' },
    { description: 'Abril', name: '04' },
    { description: 'Maio', name: '05' },
    { description: 'Junho', name: '06' },
    { description: 'Julho', name: '07' },
    { description: 'Agosto', name: '08' },
    { description: 'Setembro', name: '09' },
    { description: 'Outubro', name: '10' },
    { description: 'Novembro', name: '11' },
    { description: 'Dezembro', name: '12' },
  ],

  cnpjValidate: {
    name: 'cnpj',
    message: 'Campo obrigatório',
    type: 'cnpj',
    required: true,
  },

  HORARIO_INDISPONIBILIDADE: [
    { name: 'TODOS', description: 'Todos os horários' },
    { name: 'SELECIONAR', description: 'Selecionar horários' },
  ],

  TELEFONES: [
    { value: 'CELULAR_WHATSAPP', name: 'Whatsapp' },
    { value: 'CELULAR', name: 'Celular' },
    { value: 'COMERCIAL', name: 'Comercial' },
    { value: 'RESIDENCIAL', name: 'Residêncial' },
  ],


  CODIGOS_PAISES: [
    { value: '+27', name: 'África do Sul (+27)' },
    { value: '+355', name: 'Albânia (+355)' },
    { value: '+49', name: 'Alemanha (+49)' },
    { value: '+1684', name: 'Am. Samoa (+1-684)' },
    { value: '+376', name: 'Andorra (+376)' },
    { value: '+244', name: 'Angola (+244)' },
    { value: '+1264', name: 'Anguilla (+1-264)' },
    { value: '+1268', name: 'Antígua e Barbuda (+1-268)' },
    { value: '+966', name: 'Arábia Saudita (+966)' },
    { value: '+213', name: 'Argélia (+213)' },
    { value: '+54', name: 'Argentina (+54)' },
    { value: '+374', name: 'Armênia (+374)' },
    { value: '+297', name: 'Aruba (+297)' },
    { value: '+61', name: 'Austrália (+61)' },
    { value: '+43', name: 'Áustria (+43)' },
    { value: '+994', name: 'Azerbaijão (+994)' },
    { value: '+1242', name: 'Bahamas (+1242)' },
    { value: '+973', name: 'Bahrein (+973)' },
    { value: '+880', name: 'Bangladesh (+880)' },
    { value: '+1246', name: 'Barbados (1-246)' },
    { value: '+32', name: 'Bélgica (+32)' },
    { value: '+501', name: 'Belize (+501)' },
    { value: '+229', name: 'Benim (+229)' },
    { value: '+591', name: 'Bolívia (+591)' },
    { value: '+387', name: 'Bósnia e Herzegovina (+387)' },
    { value: '+267', name: 'Botsuana (+267)' },
    { value: '+55', name: 'Brasil (+55)' },
    { value: '+673', name: 'Brunei (+673)' },
    { value: '+359', name: 'Bulgária (+359)' },
    { value: '+226', name: 'Burkina Faso (+226)' },
    { value: '+257', name: 'Burundi (+257)' },
    { value: '+855', name: 'Camboja (+855)' },
    { value: '+237', name: 'Camarões (+237)' },
    { value: '+1', name: 'Canadá / EUA (+1)' },
    { value: '+238', name: 'Cabo Verde (+238)' },
    { value: '+56', name: 'Chile (+56)' },
    { value: '+86', name: 'China (+86)' },
    { value: '+357', name: 'Chipre (+357)' },
    { value: '+57', name: 'Colômbia (+57)' },
    { value: '+269', name: 'Comores (+269)' },
    { value: '+242', name: 'Congo (+242)' },
    { value: '+243', name: 'Congo, Rep. Dem. (+243)' },
    { value: '+506', name: 'Costa Rica (+506)' },
    { value: '+225', name: 'Costa do Marfim (+225)' },
    { value: '+385', name: 'Croácia (+385)' },
    { value: '+53', name: 'Cuba (+53)' },
    { value: '+45', name: 'Dinamarca (+45)' },
    { value: '+1767', name: 'Dominica (+1-767)' },
    { value: '+20', name: 'Egito (+20)' },
    { value: '+503', name: 'El Salvador (+503)' },
    { value: '+971', name: 'Emirados Árabes Unidos (+971)' },
    { value: '+593', name: 'Equador (+593)' },
    { value: '+34', name: 'Espanha (+34)' },
    { value: '+1', name: 'Estados Unidos / Canadá (+1)' },
    { value: '+372', name: 'Estônia (+372)' },
    { value: '+251', name: 'Etiópia (+251)' },
    { value: '+63', name: 'Filipinas (+63)' },
    { value: '+358', name: 'Finlândia (+358)' },
    { value: '+679', name: 'Fiji (+679)' },
    { value: '+33', name: 'França (+33)' },
    { value: '+241', name: 'Gabão (+241)' },
    { value: '+220', name: 'Gâmbia (+220)' },
    { value: '+233', name: 'Gana (+233)' },
    { value: '+995', name: 'Geórgia (+995)' },
    { value: '+350', name: 'Gibraltar (+350)' },
    { value: '+30', name: 'Grécia (+30)' },
    { value: '+299', name: 'Groenlândia (+299)' },
    { value: '+590', name: 'Guadalupe (+590)' },
    { value: '+502', name: 'Guatemala (+502)' },
    { value: '+224', name: 'Guiné (+224)' },
    { value: '+245', name: 'Guiné-Bissau (+245)' },
    { value: '+592', name: 'Guiana (+592)' },
    { value: '+509', name: 'Haiti (+509)' },
    { value: '+504', name: 'Honduras (+504)' },
    { value: '+852', name: 'Hong Kong (+852)' },
    { value: '+36', name: 'Hungria (+36)' },
    { value: '+62', name: 'Indonésia (+62)' },
    { value: '+91', name: 'Índia (+91)' },
    { value: '+353', name: 'Irlanda (+353)' },
    { value: '+98', name: 'Irã (+98)' },
    { value: '+964', name: 'Iraque (+964)' },
    { value: '+354', name: 'Islândia (+354)' },
    { value: '+972', name: 'Israel (+972)' },
    { value: '+39', name: 'Itália (+39)' },
    { value: '+1876', name: 'Jamaica (+1-876)' },
    { value: '+81', name: 'Japão (+81)' },
    { value: '+962', name: 'Jordânia (+962)' },
    { value: '+254', name: 'Quênia (+254)' },
    { value: '+965', name: 'Kuwait (+965)' },
    { value: '+371', name: 'Letônia (+371)' },
    { value: '+961', name: 'Líbano (+961)' },
    { value: '+218', name: 'Líbia (+218)' },
    { value: '+370', name: 'Lituânia (+370)' },
    { value: '+352', name: 'Luxemburgo (+352)' },
    { value: '+853', name: 'Macau (+853)' },
    { value: '+389', name: 'Macedônia do Norte (+389)' },
    { value: '+261', name: 'Madagascar (+261)' },
    { value: '+60', name: 'Malásia (+60)' },
    { value: '+265', name: 'Malawi (+265)' },
    { value: '+960', name: 'Maldivas (+960)' },
    { value: '+356', name: 'Malta (+356)' },
    { value: '+223', name: 'Mali (+223)' },
    { value: '+212', name: 'Marrocos (+212)' },
    { value: '+596', name: 'Martinica (+596)' },
    { value: '+230', name: 'Maurício (+230)' },
    { value: '+52', name: 'México (+52)' },
    { value: '+377', name: 'Mônaco (+377)' },
    { value: '+258', name: 'Moçambique (+258)' },
    { value: '+264', name: 'Namíbia (+264)' },
    { value: '+977', name: 'Nepal (+977)' },
    { value: '+505', name: 'Nicarágua (+505)' },
    { value: '+227', name: 'Níger (+227)' },
    { value: '+234', name: 'Nigéria (+234)' },
    { value: '+47', name: 'Noruega (+47)' },
    { value: '+64', name: 'Nova Zelândia (+64)' },
    { value: '+968', name: 'Omã (+968)' },
    { value: '+92', name: 'Paquistão (+92)' },
    { value: '+595', name: 'Paraguai (+595)' },
    { value: '+51', name: 'Peru (+51)' },
    { value: '+63', name: 'Filipinas (+63)' },
    { value: '+48', name: 'Polônia (+48)' },
    { value: '+351', name: 'Portugal (+351)' },
    { value: '+974', name: 'Qatar (+974)' },
    { value: '+44', name: 'Reino Unido (+44)' },
    { value: '+1787', name: 'Porto Rco (+1-787)' },
    { value: '+420', name: 'República Tcheca (+420)' },
    { value: '+40', name: 'Romênia (+40)' },
    { value: '+7', name: 'Rússia (+7)' },
    { value: '+966', name: 'Arábia Saudita (+966)' },
    { value: '+221', name: 'Senegal (+221)' },
    { value: '+381', name: 'Sérvia (+381)' },
    { value: '+65', name: 'Singapura (+65)' },
    { value: '+963', name: 'Síria (+963)' },
    { value: '+94', name: 'Sri Lanka (+94)' },
    { value: '+46', name: 'Suécia (+46)' },
    { value: '+41', name: 'Suíça (+41)' },
    { value: '+66', name: 'Tailândia (+66)' },
    { value: '+255', name: 'Tanzânia (+255)' },
    { value: '+216', name: 'Tunísia (+216)' },
    { value: '+90', name: 'Turquia (+90)' },
    { value: '+380', name: 'Ucrânia (+380)' },
    { value: '+971', name: 'Emirados Árabes (+971)' },
    { value: '+598', name: 'Uruguai (+598)' },
    { value: '+58', name: 'Venezuela (+58)' },
    { value: '+84', name: 'Vietnã (+84)' },
  ].sort((a, b) => a.name.localeCompare(b.name, 'pt')),


  TIPO_AGENDA_CONSULTAS: 'CONSULTAS',
  TIPO_AGENDA_EXAMES: 'EXAMES',
  TIPO_ATENDIMENTO_PARTICULAR: 'PARTICULAR',
  TIPO_ATENDIMENTO_CONVENIO: 'CONVENIO',
  TIPO_ATENDIMENTO_CORTESIA: 'CORTESIA',
  TIPO_CONSULTA_PRIMEIRA: 'PRIMEIRA',
  TIPO_CONSULTA_RETORNO: 'RETORNO',
  TIPO_CONSULTA_COMUM: 'COMUM',
  TIPO_MEDICAMENTO: 'medicamento',
  TIPO_MARCACAO: 'MARCACAO',
  TIPO_ENCAIXE: 'ENCAIXE',
  TIPO_FORMULA: 'formula',
  TIPO_LOGIN_ONLINE: 'ONLINE',
  TIPO_LOGIN_INTERNO: 'INTERNO',
  TIPO_EXAMES_OUTROS: 'examesOutros',

  TITULO_PAGINA_AGENDA: 'Agenda',
  TITULO_PAGINA_AGENDA_EXAMES: 'Agenda de exames',
  TITULO_AGENDA_ONLINE: 'Agendamento Online',
  TITULO_AGENDA_ONLINE_SUCESSO: 'Agendamento realizado',
  TITULO_PAGINA_PACIENTES: 'Pacientes',
  TITULO_PAGINA_PROFISSIONAIS: 'Profissionais de saúde',
  TITULO_PAGINA_USUARIOS: 'Usuários do sistema',
  TITULO_PAGINA_ESTABELECIMENTO: 'Estabelecimento',
  TITULO_PAGINA_EXAMES: 'Exames',
  TITULO_PAGINA_MODELOS: 'Modelos de documentos',
  TITULO_PAGINA_FINANCEIRO: 'Financeiro',
  TITULO_PAGINA_MODELOS_ANAMNESE: 'Modelos de anamnese',
  TITULO_PAGINA_MODELOS_RECEITUARIO: 'Modelos de receituário',
  TITULO_PAGINA_RELATORIOS_CONSULTA: 'Relatórios - Consultas',
  TITULO_PAGINA_RELATORIOS_EXAMES: 'Relatórios - Exames',
  TITULO_EMPRESAS_FINANCEIRO: 'Financeiro - Empresas',
  TITULO_ESTABELECIMENTO_FINANCEIRO: 'Financeiro - Estabelecimentos',
  TITULO_USUARIOS_FINANCEIRO: 'Financeiro - Usuários',
  TITULO_PAGINA_INTEGRACAO_SASCCONNECT: 'Integração Sascconnect',
  TITULO_PAGINA_PAGAMENTO: 'Pagamento',
  TITULO_VOUCHER_SOLUTI: 'Voucher Soluti',
  TITULO_DASHBOARD: 'Dashboard',
  TITULO_PAGINA_EMPRESAS: 'Empresas',
  TITULO_PAGINA_DASHBOARD: 'DashBoard Gerencial',
  TITULO_CONVENIO: 'Convênio',
  TITULO_DASHBORAD_FINANCEIRO: 'DashBoard Financeiro',
  TITULO_GESTAO_ESTOQUE: 'Gestão de Estoque',
  TITULO_ESTOQUE_PRODUTOS: 'Estoque: Produtos',
  TITULO_ESTOQUE_ENTRADA: 'Estoque: Entradas',
  TITULO_ESTOQUE_SAIDA: 'Estoque: Saídas',
  TITULO_ESTOQUE_REL_MOVIMENTACAO:
    'Estoque: Relatório de movimentação de estoque',
  TITULO_ESTOQUE_REL_POSICAO: 'Estoque: Relatório de posição de estoque',
  TITULO_ESTOQUE_AJUSTE: 'Estoque: Ajuste de estoque',

  // CRUD_ESTOQUE: 'CRUD_USUARIOS',
  MENU_ESTOQUE: 'MENU_USUARIO',
  TITULO_AGENDAMENTO_RAPIDO: 'Agendamento rápido',
  TITULO_PACOTES: 'Titulo pacotes',
  TITULO_DASHBORAD_FINANCEIRO: 'DashBoard Financeiro',
  TITULO_PARAMETRIZACAO_TRIAGEM: 'Parametrização triagem',
  TITULO_PARAMETRIZACAO_GERAL: 'Parametrização geral',

  TITULO_PARAMETRIZACAO_ATENDIMENTO_PRIORITARIO:
    'Parametrização atendimento prioritário',

  TITULO_PAGINA_PACOTES: 'Pacotes',
  codeGoogle: 'AIzaSyCgj5WxP4p7O9K-9WZIry2zqdw4C2LbxIA',
  razaoSocialValidate: {
    name: 'razaoSocial',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  nomeFantasiaValidate: {
    name: 'nomeFantasia',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },

  inscricaoEstadualValidate: {
    name: 'inscricaoEstadual',
    message: 'Campo obrigatório',
    type: 'number',
    required: true,
  },

  inscricaoMunicipalValidate: {
    name: 'inscricaoMunicipal',
    message: 'Campo obrigatório',
    type: 'number',
    required: true,
  },
  emailComercialValidate: {
    name: 'emailComercial',
    message: 'Campo obrigatório',
    type: 'email',
    required: true,
  },
  telefoneComercialValidate: {
    name: 'telefoneComercial',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  // Address
  cepValidate: {
    name: 'cep',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  ruaValidate: {
    name: 'rua',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  numeroValidate: {
    name: 'numero',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  complementoValidate: {
    name: 'complemento',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  bairroValidate: {
    name: 'bairro',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  paisValidate: {
    name: 'pais',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  estadoValidate: {
    name: 'estado',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  cidadeValidate: {
    name: 'cidade',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  horaFuncionamentoValidate: {
    name: 'horaFuncionamento',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  messageCampoObrigatorio: 'Campos obrigatórios não foram preenchidos',
  messageSucesso: 'Registro salvo com sucesso.',
  messageError: 'Ops, desculpe houve um erro interno ao processar requisição.',
  defaultFilter: {
    status: 'true',
  },
  PAIS_DEFAULT: { id: 1, nome: 'Brasil' },
  ROLE_REPRESENTANTE_LEGAL: 'ROLE_REPRESENTANTE_LEGAL',
  VIEW: 'VIEW',
  REPORT: 'REPORT',
  ROLE_REPARAR_OS: 'ROLE_REPARAR_OS',
  CONSULTA_OS: 'CONSULTA_OS',
  PJ: 'PJ',
  PF: 'PF',
  MONTH_ARRAY: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  MENU_MODELO: 'MENU_MODELO',
  MENU_MODELO_ANAMNESE: 'MENU_MODELO_ANAMNESE',
  MENU_MODELO_RECEITUARIO: 'MENU_MODELO_RECEITUARIO',
  TIPO_INPUT_FORMULARIO: [
    { name: 'TEXTO', description: 'Texto' },
    { name: 'CPF', description: 'Cpf' },
    { name: 'DATA', description: 'Data' },
    { name: 'NUMERO', description: 'Númerico' },
    { name: 'NUMERO', description: 'Númerico' },
    { name: 'NUMERO', description: 'Númerico' },
  ],

  TIPO_ENTRADA_MANUAL: '1',
  TIPO_ENTRADA_NOTA_FISCAL: '0',
  TIPO_ENTRADA_IMPORTACAO_XML: 'IMPORTACAO_XML',
  TIPO_NOTA_FISCAL_MANUAL: 'MANUAL',
  TIPO_NOTA_FISCAL_ELETRONICA: 'ELETRONICA',

  TIPO_VENDA: 'VENDA',
  TIPO_AJUSTE: 'AJUSTE',
  TIPO_CONSUMO_INTERNO: 'CONSUMO_INTERNO',
  TIPO_TRANSFERENCIA: 'TRANSFERENCIA',
  TIPO_OUTRAS_SAIDAS: 'OUTRAS_SAIDAS',

  TIPO_COMPRA: 'COMPRA',
  TIPO_ENTRADA_AJUSTE: 'AJUSTE',
  TIPO_DEVOLUCAO_VENDA: 'DEVOLUCAO_VENDA',
  TIPO_ENTRADA_TRANSFERENCIA: 'TRANSFERENCIA',
  TIPO_ENTRADA_OUTROS: 'OUTROS',
  TIPO_SALDO_INICIAL: 'SALDO_INICIAL',
  TIPOS_SALDO_INICIAL: 'SALDO_INICIAL',
  TIPO_UNIDADE_PADRAO: 'PADRAO',
  TIPO_UNIDADE_FRACAO: 'FRACAO',
};

export const objectsEnuns = {
  TIPO_ENTRADA_NOTA_FISCAL: [
    { label: 'Manual', value: objectsConstants.TIPO_ENTRADA_MANUAL },
    { label: 'Nota Fiscal', value: objectsConstants.TIPO_ENTRADA_NOTA_FISCAL },
    {
      label: 'Importação do XML',
      value: objectsConstants.TIPO_ENTRADA_IMPORTACAO_XML,
    },
  ],

  TIPO_ENTRADA: [
    { label: 'Ajuste', value: objectsConstants.TIPO_ENTRADA_AJUSTE },
    { label: 'Compra', value: objectsConstants.TIPO_COMPRA },
    { label: 'Devolução venda', value: objectsConstants.TIPO_DEVOLUCAO_VENDA },
    {
      label: 'Transferência',
      value: objectsConstants.TIPO_ENTRADA_TRANSFERENCIA,
    },
    { label: 'Saldo inicial', value: objectsConstants.TIPO_SALDO_INICIAL },
    { label: 'Outras entradas', value: objectsConstants.TIPO_ENTRADA_OUTROS },
  ],

  TIPO_SAIDA_NOTA_FISCAL: [
    { label: 'Ajuste', value: objectsConstants.TIPO_AJUSTE },
    { label: 'Consumo interno', value: objectsConstants.TIPO_CONSUMO_INTERNO },
    {
      label: 'Transferência',
      value: objectsConstants.TIPO_TRANSFERENCIA,
    },
    { label: 'Venda', value: objectsConstants.TIPO_VENDA },
    { label: 'Outras saídas', value: objectsConstants.TIPO_OUTRAS_SAIDAS },
  ],

  TIPO_NOTA_FISCAL: [
    {
      label: 'Nota fiscal comum',
      value: objectsConstants.TIPO_NOTA_FISCAL_MANUAL,
    },
    {
      label: 'Nota fiscal eletrônica',
      value: objectsConstants.TIPO_NOTA_FISCAL_ELETRONICA,
    },
  ],
  SITUACAO_NOTA_FISCAL: [
    { label: 'Ativa', value: 'ATIVA' },
    { label: 'Cancelada', value: 'CANCELADA' },
  ],
  SITUACAO_PRODUTO: [
    { label: 'Ativo', value: 'ATIVO' },
    { label: 'Inativo', value: 'INATIVO' },
    { label: 'Suspenso', value: 'SUSPENSO' },
  ],

  SITUACAO_ENTRADA_ESTOQUE: [
    { label: 'Ativo', value: 'ATIVO' },
    { label: 'Inativo', value: 'INATIVO' },
    { label: 'Suspenso', value: 'SUSPENSO' },
  ],

  SITUACAO_SAIDA_ESTOQUE: [
    { label: 'Ativo', value: 'ATIVO' },
    { label: 'Inativo', value: 'INATIVO' },
    { label: 'Suspenso', value: 'SUSPENSO' },
  ],
  TIPO_LANCAMENTO_ESTOQUE: [
    { label: 'Entradas', value: 'ENTRADAS' },
    { label: 'Saídas', value: 'SAIDAS' },
    { label: 'Entradas e Saídas', value: 'ENTRADAS_SAIDAS' },
  ],
  TIPO_ESTOQUE_QTD: [
    { label: 'Maior que', value: '>' },
    { label: 'Menor que', value: '<' },
    { label: 'Igual a', value: '=' },
  ],
  STATUS_INTEGRACAO: [
    { name: 'SUCESS', description: 'Sucesso' },
    { name: 'ERROR_TIMEOUT', description: 'Erro - Tempo limite ultrapassado' },
    { name: 'ERROR_AUTHENTICATION', description: 'Erro - Autenticação' },
    { name: 'ERROR_VALIDATION', description: 'Erro - Dados inválidos' },
    { name: 'ERROR_NETWORK', description: 'Erro - Conexão' },
    { name: 'ERROR_REFUSED', description: 'Erro - Recusada pelo receptor' },
    { name: 'ERROR_UNKNOWN', description: 'Erro - Desconhecido' },
    { name: 'PENDING', description: 'Aguarde - Transação pendente' },
    { name: 'IN_PROCESS', description: 'Aguarde - Em processamento' },
  ],
  STATUS: [
    { name: 'ATIVO', description: 'Ativo', className: 'txtGreen' },
    { name: 'INATIVO', description: 'Inativo', className: 'txtGray' },
    { name: 'AGUARANDO_PAGAMENTO', description: 'Aguardando pagamento', className: 'txtGreen' }
  ],

  TIPO_CONSULTA: [
    { name: 'PRIMEIRA', description: 'Primeira consulta', codigo: 0 },
    { name: 'COMUM', description: 'Comum', codigo: 1 },
    { name: 'RETORNO', description: 'Retorno', codigo: 2 },
  ],

  TIPO: [
    { name: 'MARCACAO', description: 'Marcação', codigo: 0 },
    { name: 'ENCAIXE', description: 'Encaixe', codigo: 1 },
  ],

  TIPO_ATENDIMENTO: [
    { name: 'CONVENIO', description: 'Convenio', codigo: 0 },
    { name: 'PARTICULAR', description: 'Particular', codigo: 1 },
    { name: 'CORTESIA', description: 'Cortesia', codigo: 1 },
  ],

  STATUS_CONSULTA: [
    { name: 'MARCADO', description: 'Marcado', codigo: 0 },
    { name: 'ATENDIDO', description: 'Atendido', codigo: 1 },
    { name: 'CANCELADO', description: 'Cancelado', codigo: 2 },
    {
      name: 'AGUARDANDO_ATENDIMENTO',
      description: 'Aguardando atendimento',
      codigo: 3,
    },
    { name: 'EM_ATENDIMENTO', description: 'Em atendimento', codigo: 4 },
    { name: 'EM_CHAMADA', description: 'Em chamada', codigo: 5 },
    { name: 'NAO_COMPARECEU', description: 'Não compareceu', codigo: 7 },
    {
      name: 'MARCACAO_RECORRENTE',
      description: 'Marcação recorrente',
      codigo: 13,
    },
  ],
};
